// src/app/components/order-tracking/order-tracking.component.ts
import { Component, OnInit } from '@angular/core';
import { OrderTrackingService } from '../services/order-tracking.service';
import { OrderTracking, TrackingEvent } from '../models/tracking.model';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDistanceToNow, format } from 'date-fns'; // optional date helper (install date-fns if desired)

@Component({
  selector: 'app-order-tracking',
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.scss']
})
export class OrderTrackingComponent implements OnInit {
  trackingNumber: string = '';
  tracking: OrderTracking | null = null;
  loading = false;
  error = '';

  // steps order for top stepper
  readonly STEPS = ['Processing', 'Packed', 'Shipped', 'Delivered'];

  constructor(
    private svc: OrderTrackingService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.trackingNumber = this.route.snapshot.paramMap.get('trackingNumber') || '';
    if (!this.trackingNumber) {
      this.error = 'Tracking number is required.';
      return;
    }
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.svc.getTracking(this.trackingNumber).subscribe({
      next: (res) => {
        this.tracking = res;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error('Tracking load error', err);
        this.error = err?.error?.message || 'Failed to load tracking details.';
      }
    });
  }

  // helper: get top step index
  stepIndex(status: string | undefined): number {
    if (!status) return 0;
    const idx = this.STEPS.indexOf(status as any);
    return idx >= 0 ? idx : 0;
  }

  // format timestamp nicely
  formatDate(ts?: string) {
    if (!ts) return '';
    try {
      // if you installed date-fns:
      // return format(new Date(ts), 'dd MMM yyyy HH:mm');
      const d = new Date(ts);
      return d.toLocaleString();
    } catch {
      return ts;
    }
  }

  // friendly relative time
  relativeTime(ts?: string) {
    if (!ts) return '';
    try {
      return formatDistanceToNow(new Date(ts), { addSuffix: true });
    } catch {
      return '';
    }
  }

  // back to orders list or home
  goBack() {
    this.router.navigate(['/orders']);
  }
}
